export default "__VITE_ASSET__faa9d88c__"